/**
 * AUTO-GENERATED by scripts/generate-model-asset-versions.mjs — do not edit.
 * Content-hash versions for fixed-URL model GLBs and portrait art, consumed
 * by resolveModelUrl / resolveModelAssets (modelRegistry.ts) as the `?v=`
 * cache buster.
 * Regenerate after changing any model GLB or portrait image:
 *   node scripts/generate-model-asset-versions.mjs
 */

export const MODEL_ASSET_VERSIONS: Record<string, string> = {
  '/model.glb': '5c182fe293',
  '/models/arc-lowres.glb': '21e54058c6',
  '/models/arc.glb': 'a749b31447',
  '/models/default-lowres.glb': 'b841ce0e60',
  '/models/default.glb': 'ac3c89e61b',
  '/models/f4-ashley-lowres.glb': '02a4982bda',
  '/models/f4-ashley.glb': '263e71dbcf',
  '/models/f4-kiera-lowres.glb': '61b329638b',
  '/models/f4-kiera.glb': '019677dae5',
  '/models/f4-naomi-lowres.glb': '15f156d9ce',
  '/models/f4-naomi.glb': 'eb20e09317',
  '/models/f4-riley-lowres.glb': '0686fb6069',
  '/models/f4-riley.glb': 'c24d5c9384',
  '/models/f4-shay-lowres.glb': '15330c15cb',
  '/models/f4-shay.glb': '995ce26104',
  '/models/f4-xandra-lowres.glb': '22220dadfd',
  '/models/f4-xandra.glb': '5ff7ec6e1a',
  '/models/gymgirl-01-lowres.glb': 'a6a9fa8050',
  '/models/gymgirl-01.glb': '0e2566817e',
  '/models/gymgirl-02-lowres.glb': '7962d5d682',
  '/models/gymgirl-02.glb': 'c421f8b560',
  '/models/gymgirl-03-lowres.glb': 'e62eb85504',
  '/models/gymgirl-03.glb': 'c8be1b4417',
  '/models/gymgirl-04-lowres.glb': 'f811852bda',
  '/models/gymgirl-04.glb': 'd78f26ad4f',
  '/models/gymgirl-05-lowres.glb': '97dbe69eb2',
  '/models/gymgirl-05.glb': '80776fb9fa',
  '/models/m4-jason-lowres.glb': '63fd988525',
  '/models/m4-jason.glb': 'f168520795',
  '/models/m4-joel-lowres.glb': '81b5faf435',
  '/models/m4-joel.glb': '68ec818c32',
  '/models/m4-male.glb': '0dfba8dfe2',
  '/models/m4-ryan-lowres.glb': '3845de9162',
  '/models/m4-ryan.glb': '4cd2b2dbfe',
  '/portraits/Arc Large.jpeg': '7dad68da58',
  '/portraits/Arc Small.jpeg': 'ec9ef055a9',
  '/portraits/arc-lg.jpg': '7dad68da58',
  '/portraits/arc-sm.jpg': 'ec9ef055a9',
  '/portraits/Ashley Large.jpeg': '6bb05f5bdd',
  '/portraits/Ashley Small.jpeg': '96dbc0e8e2',
  '/portraits/ashley-lg.jpg': '6bb05f5bdd',
  '/portraits/ashley-sm.jpg': '96dbc0e8e2',
  '/portraits/Blake Large.jpeg': '0f0cb80f52',
  '/portraits/Blake Small.jpeg': 'cf7e8d4e5b',
  '/portraits/blake-lg.jpg': '0f0cb80f52',
  '/portraits/blake-sm.jpg': 'cf7e8d4e5b',
  '/portraits/Cara Large.jpeg': 'dcc29fbba1',
  '/portraits/Cara Small.jpeg': '576b83c77f',
  '/portraits/cara-lg.jpg': 'dcc29fbba1',
  '/portraits/cara-sm.jpg': '576b83c77f',
  '/portraits/Cora Large.jpeg': '9e91fdc46e',
  '/portraits/Cora Small.jpeg': '1365451eb5',
  '/portraits/cora-lg.jpg': '9e91fdc46e',
  '/portraits/cora-sm.jpg': '1365451eb5',
  '/portraits/Harper Large.jpeg': '0024950764',
  '/portraits/Harper Small.jpeg': '210e2b8958',
  '/portraits/harper-lg.jpg': '0024950764',
  '/portraits/harper-sm.jpg': '210e2b8958',
  '/portraits/Jason Large.jpeg': '0c6d8092d2',
  '/portraits/Jason Small.jpeg': 'f7dc65bd54',
  '/portraits/jason-lg.jpg': '0c6d8092d2',
  '/portraits/jason-sm.jpg': 'f7dc65bd54',
  '/portraits/Joel Large.jpeg': '87e7c39730',
  '/portraits/Joel Small.jpeg': '6eb8916d49',
  '/portraits/joel-lg.jpg': '87e7c39730',
  '/portraits/joel-sm.jpg': '6eb8916d49',
  '/portraits/Kiera Large.jpeg': '8a08dc87d7',
  '/portraits/Kiera Small.jpeg': '25ee0a06a6',
  '/portraits/kiera-lg.jpg': '8a08dc87d7',
  '/portraits/kiera-sm.jpg': '25ee0a06a6',
  '/portraits/Mia Large.jpeg': 'd9bf45feea',
  '/portraits/Mia Small.jpeg': 'e30123660b',
  '/portraits/mia-lg.jpg': 'd9bf45feea',
  '/portraits/mia-sm.jpg': 'e30123660b',
  '/portraits/Naomi Large.jpeg': 'd3a70a35c9',
  '/portraits/Naomi Small.jpeg': '47b94d6369',
  '/portraits/naomi-lg.jpg': 'd3a70a35c9',
  '/portraits/naomi-sm.jpg': '47b94d6369',
  '/portraits/Nicola Large.jpeg': '07c1deecc8',
  '/portraits/Nicola Small.jpeg': '16ef314539',
  '/portraits/nicola-lg.jpg': '07c1deecc8',
  '/portraits/nicola-sm.jpg': '16ef314539',
  '/portraits/Petra Large.jpeg': '44a79d05fe',
  '/portraits/Petra Small.jpeg': '9edf6ba154',
  '/portraits/petra-lg.jpg': '44a79d05fe',
  '/portraits/petra-sm.jpg': '9edf6ba154',
  '/portraits/Ryan Large.jpeg': '515a97fcab',
  '/portraits/Ryan Small.jpeg': 'edf40dde65',
  '/portraits/ryan-lg.jpg': '515a97fcab',
  '/portraits/ryan-sm.jpg': 'edf40dde65',
  '/portraits/Sam Large.jpeg': '4ec2c8e4b2',
  '/portraits/Sam Small.jpeg': 'a549aa2866',
  '/portraits/sam-lg.jpg': '4ec2c8e4b2',
  '/portraits/sam-sm.jpg': 'a549aa2866',
  '/portraits/Sienna Large.jpeg': 'fa0690bc7e',
  '/portraits/Sienna Small.jpeg': '013d77648d',
  '/portraits/sienna-lg.jpg': 'fa0690bc7e',
  '/portraits/sienna-sm.jpg': '013d77648d',
  '/shenya-fullbody-ue.glb': 'a93486dc1e',
};
